/** Construit l’URL /admin/matchs avec filtres pour le deep-link depuis Occupation. */
export function buildAdminMatchsUrl(params: {
  matchId?: string;
  tableId?: number;
  tableauId?: string;
  tourId?: string;
  status?: "all" | "encours" | "a_lancer" | "bloques";
}): string {
  const search = new URLSearchParams();
  if (params.matchId) search.set("matchId", params.matchId);
  if (params.tableId != null) search.set("tableId", String(params.tableId));
  if (params.tableauId) search.set("tableauId", params.tableauId);
  if (params.tourId) search.set("tourId", params.tourId);
  if (params.status && params.status !== "all") {
    search.set("status", params.status);
  }
  const qs = search.toString();
  return qs ? `/admin/matchs?${qs}` : "/admin/matchs";
}
